<template lang="">
    <div class="wrapper">
        <div class="">
          <svg width="253" height="68" viewBox="0 0 253 68" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M62.4885 49.5589C62.4885 60.249 54.0599 65.1728 43.3 65.1728H20.2847L28.654 15.9431H49.8168C59.2621 15.9431 64.3442 20.0924 64.3442 27.4773C64.3442 33.3845 61.4141 37.5338 56.8715 39.7843C60.4551 41.6118 62.4885 44.9884 62.4885 49.5589ZM50.7119 49.2787C50.7119 46.325 48.6784 45.1293 45.8091 45.1293H35.3486L33.6753 55.1163H43.9581C48.0812 55.1163 50.7119 53.2174 50.7119 49.2787ZM38.6358 25.9996L37.0218 35.494H45.5112C49.6951 35.494 51.9672 33.5255 51.9672 29.867C51.9672 27.1954 50.1131 25.9996 47.0052 25.9996H38.6358Z" fill="#353C56"/>
          <path d="M84.4294 26.7028L83.054 35.0014H101.645L99.9112 45.4096H81.2591L79.7637 54.4114H101.703L99.7896 65.1711H66.2529L74.6223 15.9414H107.382L105.528 26.7011H84.4294V26.7028Z" fill="#353C56"/>
          <path d="M138.773 39.5024H149.235L145.708 60.249C141.404 64.0468 135.545 66.1562 129.209 66.1562C116.416 66.1562 108.167 57.365 108.167 44.4958C108.167 27.406 118.867 14.958 134.769 14.958C143.138 14.958 149.235 18.1222 153.001 24.0312L144.512 31.9069C141.763 27.8985 138.535 26.4922 134.229 26.4922C125.621 26.4922 120.121 33.7361 120.121 43.5821C120.121 50.1924 123.946 54.6237 130.822 54.6237C132.735 54.6237 134.588 54.2721 136.381 53.428L138.773 39.5024Z" fill="#353C56"/>
          <path d="M9.28166 6.34696C9.26919 2.97553 11.8453 0.159511 14.9517 0.14932C18.0253 0.139129 20.6326 2.9331 20.6981 6.30793C20.7636 9.64199 18.1719 12.5361 15.0842 12.5769C11.8173 12.6193 9.2957 9.91201 9.28166 6.34696Z" fill="#00FFB7"/>
          <path d="M8.38657 15.9432H20.2225L11.8531 65.1729H0.0172119L8.38657 15.9432Z" fill="#353C56"/>
          <path d="M227.675 42.6783C227.633 54.4265 220.379 64.2215 209.828 66.7794C197.593 69.7449 185.116 61.0183 182.724 47.5478C180.112 32.8443 188.832 21.412 199.533 18.6452C205.518 17.0979 211.219 17.7807 216.588 21.1861C217.299 21.6361 217.499 22.0166 217.231 22.9745C215.971 27.4568 217.984 33.3402 223.655 33.8463C223.903 33.8684 224.153 33.9007 224.401 33.8888C226.375 33.8022 226.355 33.8056 226.893 35.9626C227.442 38.1638 227.669 40.4041 227.675 42.6783ZM214.414 42.4932C214.388 36.5027 210.165 31.7063 204.919 31.8082C199.449 31.9135 195.539 36.5333 195.573 42.7514C195.606 48.6076 199.837 53.3225 205.067 53.2953C210.343 53.2682 214.442 48.5312 214.414 42.4932Z" fill="#353C56"/>
          <path d="M183.89 58.3262C177.899 48.8319 177.865 36.4247 183.812 26.9388C184.392 26.0132 184.244 25.5257 183.574 24.8327C179.19 20.2995 174.044 17.8368 167.635 17.886C166.866 17.8622 165.795 17.9914 164.717 18.1255C160.287 18.6758 156.325 20.6715 153.126 23.6064C155.121 27.9103 156.293 33.1348 156.293 38.7736C156.293 46.6137 154.031 53.6606 150.433 58.5317C154.288 63.4216 159.886 66.9646 166.219 67.2415C173.029 67.5404 178.875 65.3069 183.759 60.0977C184.35 59.4693 184.369 59.0854 183.89 58.3262ZM167.711 53.3056C162.511 53.3379 158.241 48.5177 158.215 42.5833C158.188 36.6896 162.456 31.8168 167.66 31.7964C172.887 31.776 177.116 36.5758 177.124 42.5357C177.13 48.5295 172.987 53.2716 167.711 53.3056Z" fill="#353C56"/>
          <path d="M214.986 6.22461C217.168 6.87512 218.988 8.07592 220.563 9.71663C223.557 12.835 225.144 16.6242 225.043 21.1863C225.001 23.0614 225.088 24.9144 225.764 26.6825C227.19 30.4276 230.866 32.853 234.524 32.4403C238.465 31.9953 239.77 31.3991 243.413 28.5661C242.947 29.9163 242.576 31.3159 241.995 32.6067C239.368 38.4545 233.308 41.8786 227.278 40.9988C221.369 40.136 216.295 35.0015 215.186 28.7138C215.019 27.7695 214.951 26.7912 214.947 25.8282C214.924 19.5626 214.93 13.297 214.929 7.0331C214.929 6.79701 214.961 6.5626 214.986 6.22461Z" fill="#00FFB7" stroke="white" stroke-miterlimit="10"/>
          <path d="M229.33 27.1037C228.709 21.2372 229.862 15.9296 233.462 11.3947C237.1 6.81226 241.735 4.54819 247.282 4.46497C248.648 4.44459 250.015 4.42083 251.38 4.4531C251.612 4.45819 252.044 4.75036 252.038 4.89642C251.971 6.85474 252.082 8.8708 251.676 10.7527C251.081 13.511 248.425 15.381 245.827 15.5186C238.534 15.9007 233.111 19.5608 229.709 26.6553C229.637 26.8047 229.548 26.9441 229.462 27.085C229.453 27.1037 229.408 27.0952 229.33 27.1037Z" fill="#00FFB7"/>
          </svg>
        </div>
        <div v-if="this.getCurrentPageRoute" class="navTrigger">
            {{ this.getCurrentPageRoute.name }}
        </div>
        <div class="sWrapper">
            <div class="icon">
                <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5991 10.7148L10.359 8.47454C10.9978 7.58967 11.3559 6.53648 11.3559 5.4218C11.3559 4.0212 10.8113 2.70386 9.81962 1.71223C7.83816 -0.269238 4.3819 -0.267428 2.40225 1.71223C1.41061 2.70386 0.865936 4.0212 0.865936 5.4218C0.865936 6.82239 1.41061 8.13977 2.40225 9.1296C3.39208 10.1194 4.70952 10.6659 6.11193 10.6659C7.22661 10.6659 8.27799 10.3076 9.16467 9.66885L11.405 11.9091C11.5696 12.0738 11.7867 12.157 12.002 12.157C12.2174 12.157 12.4344 12.0738 12.5991 11.9091C12.9285 11.5798 12.9285 11.0441 12.5991 10.7148ZM3.59662 7.93528C2.92527 7.26394 2.55621 6.37 2.55621 5.4218C2.55621 4.47178 2.92527 3.57789 3.59662 2.90654C4.26796 2.2352 5.16195 1.86602 6.11016 1.86602C7.05837 1.86602 7.95214 2.2352 8.62348 2.90654C9.29483 3.57789 9.66411 4.47178 9.66411 5.4218C9.66411 6.37 9.29483 7.26394 8.62348 7.93528C7.27898 9.27798 4.93931 9.27798 3.59662 7.93528Z" fill="#00FFB7"/>
                </svg>
            </div>
            <div class="icon">
                <svg width="16" height="16" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.41286 3.13469C3.09145 2.16658 4.21326 1.56762 5.4148 1.56762C7.43246 1.56762 9.0739 3.20889 9.0739 5.22655H9.79578C9.79578 2.81079 7.8306 0.84375 5.41304 0.84375C4.56797 0.84375 3.74836 1.08444 3.04263 1.54045C2.59567 1.82817 2.20664 2.1937 1.89178 2.61714L0.949005 1.67795V4.4104H3.69404L2.41286 3.13469Z" fill="#00FFB7"/>
                <path d="M10.098 6.52593H7.35292L8.63587 7.80164C7.95729 8.76975 6.83548 9.36871 5.63393 9.36871C3.61628 9.36871 1.97484 7.72749 1.97484 5.70984H1.25119C1.25119 8.1256 3.21817 10.0926 5.63393 10.0926C6.47899 10.0926 7.29861 9.85189 8.00434 9.39588C8.4513 9.10816 8.84033 8.74263 9.15519 8.31919L10.098 9.25838V6.52593Z" fill="#00FFB7"/>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      currentPage: this.getCurrentPageRoute && this.getCurrentPageRoute.name,
    }
  },
  components: {
  },
  watch: {
    '$route' (to, from) {
     this.currentPage = this.$store.getters.getCurrentPageRoute && this.$store.getters.getCurrentPageRoute.name;
    }
  },
  computed: {
    ...mapGetters(["getCurrentPageRoute"]),
  }
}
</script>
<style lang="scss" scoped>
    .wrapper {
        display: none;
        position: sticky;
        top: 0;
        width: 100%;
        z-index: 999;
        padding: 10px 10px;
        background-color: #E0E5EB;
        align-items: center;
        justify-content: space-between;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
        .icon {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin: 0 5px;
            transition: .3s all ease-in-out;
            cursor: pointer;
            background-color: #353C56;
            &:hover {
                background-color: #515c83;
            }
        }
        .sWrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        svg {
          height: 25px;
          max-width: 100px;
        }
        div {
          cursor: pointer;
          transition: .3s all ease-in-out;
        }
        .navTrigger {
          text-transform: capitalize;
          border-radius: 15px;
          padding: 10px 10px;
          font-weight: bold;
          color: #4e68b0;
          &:hover {
            background-color: #353C56;
            color: #E0E5EB;
          }
        }
    }

    .icon:hover svg path  {
        fill: #FFF;
    }
    .icon:hover svg rect  {
        fill: #FFF;
    }

    @media screen and  (max-width: 820px) {
        .wrapper {
        display: flex;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/global/sections/MobileTopBar.vue